import http from '@/plugins/http';

export default (userCompany) => new Promise((res, rej) => {
  const address = {
    street: userCompany.street,
    city: userCompany.city,
    zip_code: userCompany.postalcode,
    country: userCompany.country,
    countryCode: userCompany.countryCode,
    company: userCompany.name,
  };
  const updateUser = new FormData();
  // CUSTOMER ACCOUNT INFORMATION
  updateUser.append('name', userCompany.name);
  updateUser.append('logo', userCompany.avatarUrl);
  updateUser.append('billing_address', JSON.stringify(address));

  http.post('/v3/customers', updateUser)
    .then((data) => {
      res(data.data);
    })
    .catch((error) => {
      rej(error);
    });
});
